exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-padding[data-v-a2d07cee]{padding-left:10%;padding-right:10%}.common-card[data-v-a2d07cee]{border-radius:0.16rem;padding:0.32rem 0.24rem}.exchange-detail .flexEnd[data-v-a2d07cee]{margin-bottom:0.24rem}.exchange-detail .td-type-img[data-v-a2d07cee]{width:0.24rem;margin-right:0.16rem}.search-form[data-v-a2d07cee]{justify-content:end}\n", ""]);

// exports
